import { Shadow, Text, HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { Box } from 'native-base';
import React from 'react';
import { Pressable } from 'react-native';
import { useRecoilValue } from 'recoil';

import { homeGlobalState } from '../../../../../../store/home/capture/atom';

import { PendingRedemptionItemTypes } from '.';

export const PendingRedemptionItemMobile: React.FC<PendingRedemptionItemTypes> = ({ item }) => {
  const { valueVisibility } = useRecoilValue(homeGlobalState);
  const truncateText = (text, maxLength) => {
    if (text.length > maxLength) {
      return text.substring(0, maxLength) + '...';
    }
    return text;
  };

  return (
    <Shadow level={1} testId="shadow" borderRadius={BoxRadius.sm} margin={Spacing['inline.nano']}>
      <Box
        p={Spacing['inset.sm']}
        background={Color['neutral.white']}
        borderRadius={BoxRadius.sm}
        marginY={Spacing['inline.xxxs']}>
        <VStack space={Spacing['inline.xxxs']}>
          <HStack justifyContent="space-between">
            <Pressable onPress={() => {}}>
              <Text fontSize={Typography['fontsize.md']}>Cliente</Text>
              <Text fontSize={Typography['fontsize.md']}>
                {truncateText(item.customerNameNormalized, 30)}
              </Text>
            </Pressable>
          </HStack>
          <HStack justifyContent="space-between">
            <Text>Produto</Text>
            <VStack alignItems="end">
              <Text fontSize={Typography['fontsize.md']} variant="semibold">
                {item.productDescriptionNormalized}
              </Text>
              <Text fontSize={Typography['fontsize.md']} variant="regular" color={'neutral.medium'}>
                {truncateText(item.productNameNormalized, 30)}
              </Text>
            </VStack>
          </HStack>
          <HStack justifyContent="space-between">
            <Text fontSize={Typography['fontsize.md']}>Valor</Text>
            <Text
              color={valueVisibility ? 'neutral.black' : 'neutral.darkest'}
              fontSize={valueVisibility ? Typography['fontsize.md'] : Typography['fontsize.xxs']}
              letterSpacing={valueVisibility ? undefined : Typography['bullet.spacing']}>
              {valueVisibility
                ? Utils.Mask.Money(item.operationValueNormalized)
                : Typography['bullet.sequence']}
            </Text>
          </HStack>
          <HStack justifyContent="space-between">
            <Text fontSize={Typography['fontsize.md']}>Saldo</Text>
            <Text
              color={valueVisibility ? 'neutral.black' : 'neutral.darkest'}
              fontSize={valueVisibility ? Typography['fontsize.md'] : Typography['fontsize.xxs']}
              letterSpacing={valueVisibility ? undefined : Typography['bullet.spacing']}>
              {valueVisibility
                ? Utils.Mask.Money(item.customerBalanceNormalized)
                : Typography['bullet.sequence']}
            </Text>
          </HStack>
        </VStack>
      </Box>
    </Shadow>
  );
};
